export enum ResourceUtilizationView {
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    START_TO_END = 'startToEnd'
}
